<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.detailsInfo }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Aktivno
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <toggle-button
                          :width="65"
                          :height="35"
                          color="#47a447"
                          v-model="productSale.isActive"
                          :sync="true"
                      />
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.productSale.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="productSale.title"
                      />

                      <form-error
                        :model="$v.productSale.title"
                        label="Naziv"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{
                      'has-danger': $v.productSale.description.$anyError,
                    }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Opis</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Description"
                        v-model="productSale.description"
                      />

                      <form-error
                        :model="$v.productSale.description"
                        label="Opis"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.productSale.businessType.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >B2B/B2C</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                      v-model="productSale.businessType"
                      class="w-100 custom-vue-tree-select"
                      :options="b2bOrb2cOptions"
                      placeholder="B2B/B2C"
                      :disabled="true"
                    />

                      <form-error
                        :model="$v.productSale.businessType"
                        label="B2B/B2C"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.productSale.startDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Početak</label>
                    <div class="col-lg-7 col-xl-6">                      
                      <date-picker
                        type="datetime"
                        placeholder="Početak"
                        v-model="productSale.startDate"
                        input-class="form-control form-control-modern bg-body"
                        class="date-picker-width"
                        format="DD.MM.YYYY HH:mm"
                        :disabled-date="disablePastDates"
                        :lang="options"
                      ></date-picker>

                      <form-error :model="$v.productSale.startDate" label="Početak" :dirty="$v.$dirty" />
                     </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.productSale.endDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Kraj</label>
                    <div class="col-lg-7 col-xl-6">
                      <date-picker
                        type="datetime"
                        placeholder="Kraj"
                        v-model="productSale.endDate"
                        input-class="form-control form-control-modern bg-body"
                        class="date-picker-width"
                        format="DD.MM.YYYY HH:mm"
                        :disabled-date="disablePastDates"
                        :lang="options"
                      ></date-picker>

                      <form-error :model="$v.productSale.endDate" label="Kraj" :dirty="$v.$dirty" />
                     </div>
                  </div>

                  <!-- <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Postotak popusta</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Postotak popusta"
                        v-model.number="productSale.discount"
                        @input="updatePrices"
                      />
                     </div>
                  </div> -->
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-3">
                  <i class="card-big-info-icon bx bx-detail"></i>
                  <h2 class="card-big-info-title">Artikli na akciji</h2>
                  <p class="card-big-info-desc">Dodajte željene artikle</p>
                </div>

                <div class="col-9 position-relative">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga artikala</label
                        >
                        <div class="col-lg-7 col-xl-6 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle"
                            @blur="onBlurHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="article in articles"
                              :key="article.id"
                              @click="addArticle(article)"
                            >
                              <div>
                                {{ article.title }}
                              </div>
                              <div>
                              Šifra: {{ article.code }}
                              </div>
                              <div v-if="productSale.businessType == 1">
                                VPC: {{ article.vpc.toFixed(2).toString().replace('.', ',') }}
                              </div>
                              <div v-if="productSale.businessType == 2">
                                MPC: {{ article.mpc.toFixed(2).toString().replace('.', ',') }}
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            productSale.productSaleItems &&
                            productSale.productSaleItems.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Naziv</th>
                                  <th class="sorting">Šifra</th>
                                  <th class="sorting">Redovna cijena</th>
                                  <th class="sorting">Cijena na akciji</th>
                                  <th class="sorting">Procenat</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in productSale.productSaleItems"
                                  :key="item.articleId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.title }}</strong>
                                  </td>
                                  <td>
                                    {{ item.code }}
                                  </td>
                                  <td>{{ item.originalPrice.toFixed(2).toString().replace('.', ',') }}</td>
                                  <td>
                                    <div class="input-group">
                                      <input
                                        v-model.number="item.salePrice"
                                        class="form-control"
                                        @input="
                                          () => {
                                            updateDiscount(item);
                                          }
                                        "
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div class="input-group">
                                      <input
                                        v-model.number="item.discount"
                                        class="form-control"
                                        @input="
                                          () => {
                                            updatePrice(item);
                                          }
                                        "
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#delete-item-modal"
                                      class="btn"
                                      @click="selectArticleToDelete(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="card card-modern card-big-info meta-seo-section">
            <div class="card-body">
              <div class="row">
                <div class="col-3">
                  <i class="card-big-info-icon bx bx-tag"></i>
                  <h2 class="card-big-info-title">{{ translations.metaSeoDetails }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.metaSeo }}
                  </p>
                </div>

                <div class="col-9">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naslov</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="productSale.metaSeo.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Opis"
                        v-model="productSale.metaSeo.description"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Keyword</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Keyword"
                        v-model="productSale.metaSeo.keyword"
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'ProductSales' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteProductSale }}</strong>
        </h5>
        <div slot="body">
          <span v-html="modalText"></span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteProductSale"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
      <modal id="delete-item-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteArticle }}</strong>
        </h5>
        <div slot="body">
          <span v-html="articleModalText"></span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteProductSaleItem"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { debounce } from 'lodash';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import bs from 'vuejs-datepicker/dist/locale/translations/bs';

import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';
import format from 'date-fns/format';
import helpers from '@/services/helpers';

export default {
  components: {
    FormError,
    Modal,
    DatePicker,
    ToggleButton,
    Treeselect
  },
  name: 'EditProductSale',
  mixins: [translations],
  data() {
    return {
      searchField: '',
      showSearchResults: false,
      productSaleItems: [],
      productSale: {
        title: null,
        description: null,
        startDate: null,
        endDate: null,
        businessType: null,
        discount: null,
        isActive: true,
        productSaleItems: [],
        metaSeo: {
          title: null,
          description: null,
          keyword: null,
        },
      },
      deleteArticle: {},
      options: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  validations: {
    productSale: {
      ...validations,
    },
  },
  computed: {
    storeProductSale() {
      return this.$store.getters.getProductSale;
    },
    b2bOrb2cOptions() {
      return [
        { id: 1, label: 'B2B' },
        { id: 2, label: 'B2C' },
      ];
    },
    modalText() {
      return this.translations.areYouSureProductSale.replace(
        '{productSale}',
        `<strong>${this.productSale.title}</strong>`
      );
    },
    articleModalText() {
      return this.translations.areYouSureArticle.replace(
        '{article}',
        `<strong>${this.deleteArticle.title}</strong>`
      );
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    bs() {
      return bs;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    articles() {
      var data = this.$store.getters.getArticles;
      return data.filter((x) => !this.productSale.productSaleItems.map((a) => a.articleId).includes(x.id));
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        if (!id) {
          return;
        }

        this.loadProductSale(id);
      },
    },
    storeProductSale: {
      immediate: true,
      handler(newValue) {
        if (!newValue || !newValue.id) {
          return;
        }

        this.productSale = this.normalizeProductSale(newValue);
      },
    },
  },
  methods: {
    loadProductSale(id) {
      this.$store.dispatch('getProductSale', id);
    },
    normalizeProductSale(payload) {
      const normalizedIsActive = (() => {
        if (typeof payload.isActive === 'string') {
          const normalizedValue = payload.isActive.trim().toLowerCase();
          if (['true', '1', 'yes', 'y'].includes(normalizedValue)) {
            return true;
          }
          if (['false', '0', 'no', 'n', ''].includes(normalizedValue)) {
            return false;
          }
          return Boolean(normalizedValue);
        }
        return Boolean(payload.isActive);
      })();

      return {
        ...payload,
        startDate: payload.startDate ? new Date(payload.startDate) : null,
        endDate: payload.endDate ? new Date(payload.endDate) : null,
        isActive: normalizedIsActive,
        metaSeo: payload.metaSeo || {
          title: null,
          description: null,
          keyword: null,
        },
      };
    },
    formatInitialValue(date){
      const dateToFormat = new Date(date);
      return format(new Date(dateToFormat), 'MM/dd/yyyy HH:mm')
    },
    disablePastDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const payload = {
        ...this.productSale,
        startDate: helpers.formatDateForApi(this.productSale.startDate),
        endDate: helpers.formatDateForApi(this.productSale.endDate),
        isActive: Boolean(this.productSale.isActive),
        metaSeo: this.productSale.metaSeo || {
          title: null,
          description: null,
          keyword: null,
        },
      };

      if (!payload.discount || payload.discount == '') {
        delete payload.discount;
      }

      api
        .updateProductSale(payload)
        .then((response) => {
          this.$toast.info(response?.data?.info);
          this.$router.push({ name: 'ProductSales' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    deleteProductSale() {
      api
        .deleteProductSales([this.productSale.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'ProductSales' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'ProductSales' });
        });
    },
    selectArticleToDelete(article) {
      this.deleteArticle = article;
    },
    deleteProductSaleItem() {
      const { deleteArticle } = this;
      const index = this.productSale.productSaleItems.findIndex(
        (item) => item.articleId === deleteArticle.articleId
      );
      this.productSale.productSaleItems.splice(index, 1);
    },
    addArticle(article) {
      const { id, vpc, title, code, mpc } = article;

      const discount = this.productSale.discount || 0;
      const salePrice = this.productSale.businessType == 1 ? parseFloat(
        (article.vpc - article.vpc * (discount / 100)).toFixed(2),
        10 
      ) : parseFloat(
        (article.mpc - article.mpc * (discount / 100)).toFixed(2),
        10 
      );

      const parsedArticle = {
        articleId: id,
        originalPrice: this.productSale.businessType == 1 ? vpc : mpc,
        salePrice,
        discount,
        title,
        code,
      };

      const foundArticle = this.productSale.productSaleItems.find(
        (item) => item.articleId === article.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundArticle) {
        this.$toast.error('Artikal je već dodan.');
        return;
      }
      this.productSale.productSaleItems.push(parsedArticle);
    },
    // updatePrices() {
    //   const { discount, productSaleItems } = this.productSale;

    //   productSaleItems.forEach((item) => {
    //     item.salePrice = parseFloat(
    //       (item.originalPrice - item.originalPrice * (discount / 100)).toFixed(
    //         2
    //       ),
    //       10
    //     );
    //     item.discount = discount || 0;
    //   });
    // },
    updateDiscount(item) {
      const discount =
        100 -
        parseInt(((item.salePrice / item.originalPrice) * 100).toFixed(0), 10);
      item.discount = discount;
    },
    updatePrice(item) {
      const price = (1 - item.discount / 100) * item.originalPrice;
      item.salePrice = price.toFixed(2);
    },
    onSearchHandle: debounce(function () {
      this.showSearchResults = true;
      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: true,
        page: 1,
        retrieveAll: true,
        quickSearch: this.searchField.trim(),
      });
    }, 300),
    onBlurHandle: debounce(function () {
      // this.showSearchResults = false;
    }, 300),
  },
};
</script>
<style lang="scss" scoped>
.position-relative {
  position: relative;
}

.article-list {
  position: absolute;
  margin-top: 3px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1;
  left: 12px;
  right: 12px;
  top: 40px;
  overflow-y: auto;
  max-height: 200px;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 0 10px;
    cursor: pointer;
    overflow: hidden;

    &:first-child {
      border-top: none;
    }
  }
}

.card-articles {
  margin-bottom: 100px;
}

.date-picker-width {
    width: 100%;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}
</style>
